// UserManagement.js - Main Wrapper Component
import React, { useState } from "react";
import { Card, Tabs } from "antd";
import { Users, Download, BarChart3, User } from "lucide-react";
import UsersTable from "./UserTable";
import UserDetails from "./UserDetails";
import UserOrderHistory from "./UserOrderHistory";
import UserExport from "./UserExport";

function UserManagement() {
  const [activeTab, setActiveTab] = useState("users");
  const [showUserDetails, setShowUserDetails] = useState(false);
  const [showOrderHistory, setShowOrderHistory] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  // Handle view user details
  const handleViewDetails = (userId) => {
    setSelectedUserId(userId);
    setShowUserDetails(true);
  };

  // Handle view order history
  const handleViewOrderHistory = (userId) => {
    setSelectedUserId(userId);
    setShowOrderHistory(true);
  };

  // Handle user status update
  const handleUserUpdate = () => {
    setRefreshTrigger((prev) => prev + 1);
    setShowUserDetails(false);
  };

  // Close modals
  const handleCloseDetails = () => {
    setShowUserDetails(false);
    setSelectedUserId(null);
  };

  const handleCloseOrderHistory = () => {
    setShowOrderHistory(false);
    setSelectedUserId(null);
  };

  const tabItems = [
    {
      key: "users",
      label: (
        <span className="flex items-center">
          <Users className="h-4 w-4 mr-2" />
          Users Management
        </span>
      ),
      children: (
        <UsersTable
          onViewDetails={handleViewDetails}
          onViewOrderHistory={handleViewOrderHistory}
          refreshTrigger={refreshTrigger}
        />
      ),
    },
    {
      key: "export",
      label: (
        <span className="flex items-center">
          <Download className="h-4 w-4 mr-2" />
          Export Data
        </span>
      ),
      children: <UserExport />,
    },
  ];

  return (
    <div style={{ padding: "24px" }}>
      <Card
        title={
          <div style={{ display: "flex", alignItems: "center" }}>
            <User style={{ marginRight: "8px", color: "#f97316" }} />
            User Management
          </div>
        }
      >
        <Tabs
          activeKey={activeTab}
          onChange={setActiveTab}
          items={tabItems}
          size="large"
        />
      </Card>

      {/* User Details Modal */}
      <UserDetails
        visible={showUserDetails}
        userId={selectedUserId}
        onClose={handleCloseDetails}
        onUpdate={handleUserUpdate}
        onViewOrderHistory={handleViewOrderHistory}
      />

      {/* User Order History Modal */}
      <UserOrderHistory
        visible={showOrderHistory}
        userId={selectedUserId}
        onClose={handleCloseOrderHistory}
      />
    </div>
  );
}

export default UserManagement;
